module.exports = __webpack_public_path__ + "img/grl.2490aa08.svg";